import { isEmpty } from 'lodash';

/**
 * Custom Errors handler
 */
export class ApiErrors extends Error {
  /**
   * Should be called after each requests when we expect some errors or validations
   */
  public static checkOnApiError({ errors, code, message }: any) {
    if (errors && errors.length) {
      const isError = !isEmpty(errors);

      if (isError) {
        throw new ApiErrors(errors[0].text, errors[0].code);
      }
    }

    if (code) {
      throw new ApiErrors(message, code);
    }
  }

  public code: number;

  constructor(m: string, code: number) {
    super(m);
    this.name = 'API Errors';
    this.code = code;
  }
}

export default ApiErrors;
